import React from "react";
var __jsx = React.createElement;
import { forwardRef, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { Context } from '../../../global-state-context/GlobalStateProvider.js';
import styles from './Banner.style.js';
import Button from '../../atoms/Button/Button.js';
import Skeleton from '../../atoms/Skeleton/index.js';
import Img from '../../atoms/Img/Img.js';
import Headline from './Headline.js';
import RichText from './RichText.js';
import CTAs from './CTAs.js';
import Column from './Column.js';
import LayoutTwoColImgText from './LayoutTwoColImgText.js';
import LayoutTwoColText from './LayoutTwoColText.js';
import LayoutFullText from './LayoutFullText.js';
var LAYOUT = {
  TWO_COL_IMG_TEXT: 'two-col-img-text',
  TWO_COL_TEXT: 'two-col-text',
  FULL_TEXT: 'full-text'
};

// Emergency Banner v2
var Banner = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _yextInfo$c_websiteBa4, _yextInfo$entities3, _yextInfo$entities3$, _yextInfo$entities3$$, _yextInfo$c_websiteBa5, _yextInfo$entities4, _yextInfo$entities4$, _yextInfo$entities4$$;
  var className = _ref.className;
  var _useContext = useContext(Context),
    yextInfo = _useContext.yextInfo;
  var _useState = useState(true),
    isLoading = _useState[0],
    setIsLoading = _useState[1];
  var _useState2 = useState(LAYOUT.FULL_TEXT),
    layoutVariation = _useState2[0],
    setLayoutVariation = _useState2[1];
  var _useState3 = useState(false),
    isOpen = _useState3[0],
    setIsOpen = _useState3[1];
  var STATE_CLASS = {
    OPEN: 'is-open',
    OPENING: 'is-opening',
    CLOSED: 'is-closed',
    CLOSING: 'is-closing'
  };
  var _useState4 = useState(STATE_CLASS.CLOSED),
    stateClass = _useState4[0],
    setStateClass = _useState4[1];
  useEffect(function () {
    if (yextInfo) {
      setIsLoading(false);
    }
  }, [JSON.stringify(yextInfo)]);
  useEffect(function () {
    var _yextInfo$c_websiteBa, _yextInfo$c_websiteBa2, _yextInfo$entities, _yextInfo$entities$, _yextInfo$entities$$c, _yextInfo$c_websiteBa3, _yextInfo$entities2, _yextInfo$entities2$, _yextInfo$entities2$$;
    var hasImage = yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$c_websiteBa = yextInfo.c_websiteBannerExpandedImage) === null || _yextInfo$c_websiteBa === void 0 ? void 0 : _yextInfo$c_websiteBa.url;
    var hasFirstColumn = (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$c_websiteBa2 = yextInfo.c_websiteBannerExpandedFirstColumnText) === null || _yextInfo$c_websiteBa2 === void 0 ? void 0 : _yextInfo$c_websiteBa2.json) || (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$entities = yextInfo.entities) === null || _yextInfo$entities === void 0 ? void 0 : (_yextInfo$entities$ = _yextInfo$entities[0]) === null || _yextInfo$entities$ === void 0 ? void 0 : (_yextInfo$entities$$c = _yextInfo$entities$.c_websiteBannerExpandedFirstColumnText) === null || _yextInfo$entities$$c === void 0 ? void 0 : _yextInfo$entities$$c.json);
    var hasSecondColumn = (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$c_websiteBa3 = yextInfo.c_websiteBannerExpandedSecondColumnText) === null || _yextInfo$c_websiteBa3 === void 0 ? void 0 : _yextInfo$c_websiteBa3.json) || (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$entities2 = yextInfo.entities) === null || _yextInfo$entities2 === void 0 ? void 0 : (_yextInfo$entities2$ = _yextInfo$entities2[0]) === null || _yextInfo$entities2$ === void 0 ? void 0 : (_yextInfo$entities2$$ = _yextInfo$entities2$.c_websiteBannerExpandedSecondColumnText) === null || _yextInfo$entities2$$ === void 0 ? void 0 : _yextInfo$entities2$$.json);
    if (hasImage) {
      setLayoutVariation(LAYOUT.TWO_COL_IMG_TEXT);
    } else if (hasFirstColumn && hasSecondColumn) {
      setLayoutVariation(LAYOUT.TWO_COL_TEXT);
    } else {
      setLayoutVariation(LAYOUT.FULL_TEXT);
    }
  }, [yextInfo]);
  function handleToggle() {
    requestAnimationFrame(function () {
      setStateClass(!isOpen ? STATE_CLASS.OPENING : STATE_CLASS.CLOSING);
      setIsOpen(!isOpen);
    });
  }
  function handleTransitionEnd() {
    setStateClass(!isOpen ? STATE_CLASS.CLOSED : STATE_CLASS.OPEN);
  }
  return __jsx("section", {
    ref: ref,
    className: cn('nva-banner', stateClass, {
      'nva-banner--two-col-img-text': layoutVariation === LAYOUT.TWO_COL_IMG_TEXT,
      'nva-banner--two-col-text': layoutVariation === LAYOUT.TWO_COL_TEXT,
      'nva-banner--full-text': layoutVariation === LAYOUT.FULL_TEXT
    }, className),
    "aria-labelledby": "banner-heading"
  }, __jsx("div", {
    className: "nva-banner__wrapper"
  }, __jsx("div", {
    className: "nva-banner__top-wrapper l-grid",
    onTransitionEnd: handleTransitionEnd
  }, __jsx("div", {
    className: "nva-banner__top l-col-full"
  }, __jsx("div", {
    className: "nva-banner__top-inner"
  }, __jsx("div", {
    className: "nva-banner__top-icon"
  }, !isLoading ? ((yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$c_websiteBa4 = yextInfo.c_websiteBannerCollapsedIcon) === null || _yextInfo$c_websiteBa4 === void 0 ? void 0 : _yextInfo$c_websiteBa4.url) || (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$entities3 = yextInfo.entities) === null || _yextInfo$entities3 === void 0 ? void 0 : (_yextInfo$entities3$ = _yextInfo$entities3[0]) === null || _yextInfo$entities3$ === void 0 ? void 0 : (_yextInfo$entities3$$ = _yextInfo$entities3$.c_websiteBannerCollapsedIcon) === null || _yextInfo$entities3$$ === void 0 ? void 0 : _yextInfo$entities3$$.url)) && __jsx(Img, {
    src: (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$c_websiteBa5 = yextInfo.c_websiteBannerCollapsedIcon) === null || _yextInfo$c_websiteBa5 === void 0 ? void 0 : _yextInfo$c_websiteBa5.url) || (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$entities4 = yextInfo.entities) === null || _yextInfo$entities4 === void 0 ? void 0 : (_yextInfo$entities4$ = _yextInfo$entities4[0]) === null || _yextInfo$entities4$ === void 0 ? void 0 : (_yextInfo$entities4$$ = _yextInfo$entities4$.c_websiteBannerCollapsedIcon) === null || _yextInfo$entities4$$ === void 0 ? void 0 : _yextInfo$entities4$$.url),
    height: 50,
    width: 50
  }) : __jsx(Skeleton, {
    width: "50px",
    height: "50px"
  })), __jsx("div", {
    className: "nva-banner__top-content"
  }, __jsx(Banner.Headline, {
    isLoading: isLoading,
    id: "banner-heading",
    className: "nva-banner__top-headline u-h6 u-mt-0 u-mb-2",
    yextInfo: yextInfo,
    fieldId: "c_websiteBannerCollapsedHeadline",
    skeletonData: {
      className: 'u-mb-3',
      width: 'min(18ch, 100%)',
      type: 'h6'
    }
  }), __jsx(Banner.RichText, {
    isLoading: isLoading,
    className: "nva-banner__top-text",
    yextInfo: yextInfo,
    fieldId: "c_websiteBannerCollapsedText",
    skeletonData: {
      width: 'min(80ch, 100%)',
      type: 'body2'
    }
  }))), __jsx("div", {
    className: "nva-banner__expand-wrapper"
  }, __jsx(Button, {
    className: "nva-banner__expand",
    styleType: "text",
    onClick: handleToggle,
    "aria-expanded": isOpen,
    "aria-controls": "banner-bottom"
  }, !isOpen ? __jsx(React.Fragment, null, __jsx("span", {
    className: "max-md:u-visually-hidden"
  }, "Learn More"), __jsx("svg", {
    "class": "nva-banner__expand-icon",
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, __jsx("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z",
    fill: "currentColor"
  }))) : __jsx(React.Fragment, null, __jsx("span", {
    className: "max-md:u-visually-hidden"
  }, "Collapse"), __jsx("svg", {
    "class": "nva-banner__collapse-icon",
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, __jsx("path", {
    d: "M19 13H5v-2h14z",
    fill: "currentColor"
  }))))))), __jsx("div", {
    className: "nva-banner__bottom-wrapper",
    id: "banner-bottom"
  }, __jsx("div", {
    className: "nva-banner__bottom"
  }, __jsx("div", {
    className: "nva-banner__bottom-inner"
  }, __jsx("div", {
    className: "nva-banner__bottom-grid l-grid"
  }, layoutVariation === LAYOUT.TWO_COL_IMG_TEXT ? __jsx(Banner.LayoutTwoColImgText, {
    yextInfo: yextInfo,
    isLoading: isLoading
  }) : null, layoutVariation === LAYOUT.TWO_COL_TEXT ? __jsx(Banner.LayoutTwoColText, {
    yextInfo: yextInfo,
    isLoading: isLoading
  }) : null, layoutVariation === LAYOUT.FULL_TEXT ? __jsx(Banner.LayoutFullText, {
    yextInfo: yextInfo,
    isLoading: isLoading
  }) : null, __jsx("div", {
    className: "nva-banner__bottom-ctas-wrapper l-col-full"
  }, __jsx(Banner.CTAs, {
    yextInfo: yextInfo
  }))))))));
});
Banner.Headline = Headline;
Banner.RichText = RichText;
Banner.CTAs = CTAs;
Banner.Column = Column;
Banner.LayoutTwoColImgText = LayoutTwoColImgText;
Banner.LayoutTwoColText = LayoutTwoColText;
Banner.LayoutFullText = LayoutFullText;
export default styled(Banner).withConfig({
  componentId: "sc-1qjqhwx-0"
})(["", ";"], styles);